/** Query param used on /signup and /auth to select the form panel. */
export const AUTH_MODE_QUERY_KEY = 'mode';

export const AUTH_MODES = {
	SIGN_IN: 'SIGN_IN',
	SIGN_UP: 'SIGN_UP',
	FORGOT_PASSWORD: 'FORGOT_PASSWORD',
	RESET_PASSWORD: 'RESET_PASSWORD',
};

const PARAM_TO_MODE = {
	signup: AUTH_MODES.SIGN_UP,
	'sign-up': AUTH_MODES.SIGN_UP,
	create: AUTH_MODES.SIGN_UP,
	'create-one': AUTH_MODES.SIGN_UP,
	signin: AUTH_MODES.SIGN_IN,
	'sign-in': AUTH_MODES.SIGN_IN,
	login: AUTH_MODES.SIGN_IN,
	forgot: AUTH_MODES.FORGOT_PASSWORD,
	'forgot-password': AUTH_MODES.FORGOT_PASSWORD,
	reset: AUTH_MODES.RESET_PASSWORD,
	'reset-password': AUTH_MODES.RESET_PASSWORD,
};

const MODE_TO_PARAM = {
	[AUTH_MODES.SIGN_UP]: 'signup',
	[AUTH_MODES.SIGN_IN]: 'signin',
	[AUTH_MODES.FORGOT_PASSWORD]: 'forgot',
	[AUTH_MODES.RESET_PASSWORD]: 'reset',
};

/** Default panel for a path when `?mode=` is absent. */
export const getDefaultAuthModeForPath = (pathname = '') => {
	const path = String(pathname).replace(/\/$/, '') || '/';
	if (path === '/signup') return AUTH_MODES.SIGN_UP;
	return AUTH_MODES.SIGN_IN;
};

export const authModeToParam = (mode) => MODE_TO_PARAM[mode] || null;

export const authModeFromParam = (raw) => {
	if (raw == null || raw === '') return null;
	const key = String(raw).trim().toLowerCase();
	return PARAM_TO_MODE[key] || null;
};

/**
 * Resolve auth panel from path + search (path default when mode is omitted).
 */
export const resolveAuthModeFromLocation = ({ pathname, search } = {}) => {
	const params = new URLSearchParams(
		typeof search === 'string'
			? search.startsWith('?')
				? search.slice(1)
				: search
			: search || '',
	);
	const fromParam = authModeFromParam(params.get(AUTH_MODE_QUERY_KEY));
	if (fromParam) return fromParam;
	return getDefaultAuthModeForPath(pathname);
};

/**
 * Merge a new auth mode into existing search params.
 * Omits `mode` when it matches the path default (cleaner URLs).
 */
export const buildAuthModeSearchParams = ({
	pathname,
	currentSearch,
	mode,
}) => {
	const next = new URLSearchParams(
		typeof currentSearch === 'string'
			? currentSearch.startsWith('?')
				? currentSearch.slice(1)
				: currentSearch
			: currentSearch || '',
	);
	const param = authModeToParam(mode);
	const pathDefault = getDefaultAuthModeForPath(pathname);

	if (!param || mode === pathDefault) {
		next.delete(AUTH_MODE_QUERY_KEY);
	} else {
		next.set(AUTH_MODE_QUERY_KEY, param);
	}

	return next;
};
